import { useEffect, type JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';

/**
 * トップ画面
 */
export default function Index(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const navigate = useNavigate();

  const [acctState] = useAtom(AcctState);

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */
  useEffect(() => {
    if (acctState.company == null) {
      navigate('/signin');
    } else {
      navigate(`/ws/${acctState.company.cd}`);
    }
  }, [navigate, acctState]);

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return <></>;
}
